import { render, staticRenderFns } from "./TableFooterSummary.vue?vue&type=template&id=6e705d64&scoped=true"
import script from "./TableFooterSummary.vue?vue&type=script&lang=js"
export * from "./TableFooterSummary.vue?vue&type=script&lang=js"
import style0 from "./TableFooterSummary.vue?vue&type=style&index=0&id=6e705d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e705d64",
  null
  
)

export default component.exports